import { formatPreferenceNumber } from './legacyPreferenceFormatting';

// Keep the legacy API vocabulary at this boundary. Missing metrics are unknown,
// while a real zero remains a useful portfolio value.
export function mapLegacyPortfolioOption(portfolio) {
  const metric = (key, label, field, suffix = '', title = '') => {
    const raw = portfolio[field];
    const formatted = formatPreferenceNumber(raw);
    return { key, label, value: formatted !== '-' ? `${formatted}${suffix}` : '—', title };
  };
  return {
    name: portfolio.idc,
    value: portfolio.name,
    details: [
      metric('capital', 'Capital', 'real_capital', portfolio.currency ? ` ${portfolio.currency}` : ''),
      metric('risk', 'Riesgo / op.', 'risk', ' %'),
      metric('waiting', 'En espera', 'waiting_tickers_count', '', 'Número de valores distintos en espera'),
      metric('open', 'Posiciones abiertas', 'open_positions_count'),
      metric('globalRisk', 'Riesgo global', 'global_risk', ' %', 'Suma del riesgo de posiciones abiertas, alcistas y bajistas; excluye valores en espera')
    ]
  };
}
